import React from 'react';
import { PapiAttachmentFile } from '@wix/da-papi-types';
import { FullViewProps } from '../types';
import Image from './Image';

interface Props extends Omit<FullViewProps, 'deviation'> {
  attachment: PapiAttachmentFile;
  isPublished?: boolean;
}

/** Wraps Full Image for use with PapiAttachmentFile (e.g.
 *  a deviation's additionalMedia) */
const ImageAttachment: React.FC<Props> = ({ attachment, isPublished = false, ...props }) => {
  return (
    <Image
      source={attachment}
      allowFullviewSrcsetForPngs={isPublished}
      altText={attachment.caption?.excerpt ?? attachment.filename}
      {...props}
    />
  );
};
ImageAttachment.displayName = 'ImageAttachment';

export default ImageAttachment;
